import React from 'react';
import { components } from 'react-select';

import { ReactComponent as TickIcon } from '../../../../../../assets/images/selected.svg';

import styles from '../Mapping.module.scss';

const CustomOption = (props) => {
  const { data, isSelected } = props;
  return (
    <components.Option {...props}>
      <div className={styles.optionCont}>
        <TickIcon className={isSelected ? styles.visible : styles.hidden} />
        <p className={styles.optionLabel}>{data.label}</p>
      </div>
    </components.Option>
  );
};

export default CustomOption;
